import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import FastImage from '../../../common/FastImage';
import {globalConst} from '../../../utils/globalConstant';
import {waitingClock, wallet_failure} from '../../../utils/images';
import {Button} from '../../../components/core/Button';

const WaitTimeClockBottomSheet = ({onOkayClick, error}) => {
  const [time, setTime] = React.useState(25);
  const timerRef = React.useRef(time);
  // React.useEffect(() => {
  //   const timerId = setInterval(() => {
  //     timerRef.current -= 1;
  //     if (timerRef.current < 0) {
  //       clearInterval(timerId);
  //     } else {
  //       setTime(timerRef.current);
  //     }
  //   }, 1000);
  //   return () => {
  //     clearInterval(timerId);
  //   };
  // }, []);
  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        paddingTop: 30,
        paddingBottom: 24,
        paddingHorizontal: 16,
      }}>
      <FastImage
        style={{
          height: 60,
          width: 60,
        }}
        source={error ? wallet_failure() : waitingClock()}
      />
      <Text
        style={[
          globalFontStyle.appFontTitle,
          {marginTop: 10, textAlign: 'center'},
        ]}>
        {error ? error : 'Event Creation in progress'}
      </Text>
      {!error ? (
        <Text
          style={[
            globalFontStyle.appFontSubText,
            {marginTop: 10, textAlign: 'center', color: Color.grey2},
          ]}>
          Our team is reviewing your event details. We'll notify you once your
          event gets visible to users.
        </Text>
      ) : null}

      <View style={{width: '100%', marginTop: 15}}>
        <Button
          variant="primary"
          onPress={() => {
            setTimeout(() => {
              error ? onOkayClick() : onOkayClick(true);
            }, globalConst?.buttonTimer);
          }}
        >
          Okay
        </Button>
      </View>
    </View>
  );
};

export default WaitTimeClockBottomSheet;

const styles = StyleSheet.create({
  commonBtnStyle: {
    paddingVertical: 12,
    flex: 1,
    alignItems: 'center',
    borderRadius: 8,
    borderColor: Color.black,
    borderWidth: 1,
    width: '100%',
    marginTop: 35,
  },
});
